import mitt from 'mitt'

export const APP_EVENTS = {
	TEAM_CHANGING: 'teamchanging',
	TEAM_CHANGED: 'teamchanged',
	PROJECT_CHANGING: 'projectchanging',
	PROJECT_CHANGED: 'projectchanged',
	SCHEDULE_MODE: 'scheduleMode',
	VIDEO_UPLOADED: 'video-uploaded',
	OPEN_VOD_UPLOADER: 'open-vod-uploader',
	PLAYOUT_FILE_REMOVED: 'playout-file-removed',
	PLAYOUT_VIEW_SCHEDULE: 'playout-view-schedule',
	SELECT_LIVE_TO_VOD_STREAM_TYPE: 'select-live-to-vod::set-stream-type',
	TOGGLE_FINISHED: 'togglefinished',
}

export const appEventBus = mitt()

export function emitAppEvent(event, payload) {
	appEventBus.emit(event, payload)
}

export function onAppEvent(event, handler) {
	appEventBus.on(event, handler)
	return () => appEventBus.off(event, handler)
}
